import { ReactNode, forwardRef } from 'react';
import classNames from 'classnames';

import { Box, BoxProps } from '../Box/Box';

import {
  fontFamily,
  fontWeight,
  textSizeTrimmed,
  textSizeUntrimmed,
  tone as textTone,
} from '../../css/typography.css';

export interface TextProps {
  id?: string;
  tone?: keyof typeof textTone;
  weight?: keyof typeof fontWeight;
  size?: keyof typeof textSizeTrimmed;
  align?: BoxProps['textAlign'];
  /** capitalize, uppercase or lowercase the provided text */
  transform?: BoxProps['textTransform'];
  untrimmed?: boolean;
  decoration?: BoxProps['textDecoration'];
  className?: string;
  children?: ReactNode;
  htmlFor?: string;
  display?: 'block' | 'inline';
  title?: string;
}

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  (
    {
      id,
      size = 'medium',
      weight = 'regular',
      tone = 'neutral',
      align,
      transform,
      untrimmed,
      className,
      children,
      decoration,
      htmlFor,
      title,
      display = 'block',
    }: TextProps,
    ref
  ) => {
    return (
      <Box
        id={id}
        display={display}
        component="span"
        textAlign={align}
        textTransform={transform}
        textDecoration={decoration}
        className={classNames(
          fontFamily,
          fontWeight[weight],
          textTone[tone],
          untrimmed ? textSizeUntrimmed[size] : textSizeTrimmed[size],
          className
        )}
        ref={ref}
        htmlFor={htmlFor}
        title={title}
      >
        {children}
      </Box>
    );
  }
);

Text.displayName = 'Text';
